const Illustration = ({ className = '', alt = 'Laptop illustration' }) => {
    return (
        <img
            className={className}
            src="/images/illustration.png"
            alt={alt}
            fetchpriority="high"
            width="494"
            height="283"
            style={{ maxWidth: '100%', height: 'auto' }}
        />
    );
};

export default Illustration;

